import AbstractNotificationsCollection from './YPAbstractNotificationsCollection';
import UpdateNotification from './YPUpdateNotificationObject';

export const processUpdateNotifications = (updatenotificationsJSON) =>
  updatenotificationsJSON.map(
    (notification) =>
      new UpdateNotification(
        notification.id,
        notification.timestamp,
        notification.isRead,
        notification.notificationMessage,
        notification.tag
      )
  );

export default class UpdateNotifications extends AbstractNotificationsCollection {
  shouldShowUpdateNotifications(showAllToggle) {
    return this.notifications.length !== 0;
  }

  updateNotifications(notificationsInJSON) {
    const newUpdateNotifications = processUpdateNotifications(notificationsInJSON);
    if (!this.equalNotifications('notifications', newUpdateNotifications)) {
      this.versionStamp++;
      if (newUpdateNotifications.length > this.notifications.length)
        this.versionStampQuantity++;
      if (
        newUpdateNotifications.filter((not) => !not.isRead).length >
        this.notifications.filter((not) => !not.isRead).length
      )
        this.versionStampUnread++;
      this.notifications = newUpdateNotifications;
    }
  }
}
